// extracted by mini-css-extract-plugin
export default {"contentPanel":"x8ZlPSxYIgSkL57jEdF6","contentPanelContent":"MUn7YAAvST0zD7GRD7ms","contentPanelWithSidePanel":"sIOejVz0_ZF9M8HMWEFM"};